var _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60815 1C13.7544 1 17.1155 4.36117 17.1155 8.50739C17.1155 10.4197 16.6493 12.3031 15.7571 13.9945L10.3846 24.1797C10.0095 24.891 8.99083 24.891 8.61565 24.1797L3.24322 13.9945C2.35105 12.3031 1.88477 10.4197 1.88477 8.50739C1.88477 4.36117 5.24594 1 9.39215 1H9.60815Z",
    stroke: "#202737",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5003,
    cy: 8.61541,
    r: 3.23077,
    fill: "#202737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4457 24.6637L13.1127 23.0388C12.7224 22.8924 12.4639 22.5193 12.4639 22.1025V17.5023V13.4899C12.4639 12.8393 13.0753 12.362 13.7064 12.5197L17.4457 13.4546V24.6637Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1127 23.0388L12.7616 23.9751H12.7616L13.1127 23.0388ZM17.4457 24.6637L17.0946 25.6C17.4017 25.7151 17.7457 25.6724 18.0153 25.4856C18.2849 25.2988 18.4457 24.9916 18.4457 24.6637H17.4457ZM17.4457 13.4546H18.4457V12.6738L17.6882 12.4844L17.4457 13.4546ZM12.7616 23.9751L17.0946 25.6L17.7968 23.7273L13.4639 22.1025L12.7616 23.9751ZM18.4457 24.6637V13.4546H16.4457V24.6637H18.4457ZM17.6882 12.4844L13.9489 11.5496L13.4639 13.4899L17.2031 14.4247L17.6882 12.4844ZM11.4639 13.4899V17.5023H13.4639V13.4899H11.4639ZM11.4639 17.5023V22.1025H13.4639V17.5023H11.4639ZM13.4639 22.1025L13.4639 22.1025H11.4639C11.4639 22.9362 11.981 23.6824 12.7616 23.9751L13.4639 22.1025ZM13.9489 11.5496C12.6866 11.234 11.4639 12.1887 11.4639 13.4899H13.4639L13.4639 13.4899L13.9489 11.5496Z",
    fill: "#0076CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0584 24.157L22.4277 22.7955V17.5023V12.2091L26.6521 13.2652C27.0973 13.3765 27.4096 13.7765 27.4096 14.2353V23.2207C27.4096 23.9189 26.7122 24.4021 26.0584 24.157Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4277 22.7955H21.4277V23.4885L22.0766 23.7318L22.4277 22.7955ZM26.0584 24.157L26.4096 23.2207H26.4096L26.0584 24.157ZM22.4277 12.2091L22.6703 11.239C22.3715 11.1643 22.055 11.2314 21.8123 11.4209C21.5696 11.6104 21.4277 11.9012 21.4277 12.2091H22.4277ZM22.0766 23.7318L25.7073 25.0933L26.4096 23.2207L22.7789 21.8591L22.0766 23.7318ZM28.4096 23.2207V14.2353H26.4096V23.2207H28.4096ZM26.8946 12.2951L22.6703 11.239L22.1852 13.1792L26.4096 14.2353L26.8946 12.2951ZM21.4277 12.2091V17.5023H23.4277V12.2091H21.4277ZM21.4277 17.5023V22.7955H23.4277V17.5023H21.4277ZM28.4096 14.2353C28.4096 13.3176 27.785 12.5176 26.8946 12.2951L26.4096 14.2353V14.2353H28.4096ZM25.7073 25.0933C27.0148 25.5836 28.4096 24.6171 28.4096 23.2207H26.4096H26.4096L25.7073 25.0933Z",
    fill: "#0076CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4271 12.209L17.4453 13.4545V19.3704V24.6636L22.4271 22.7954V12.209Z",
    fill: "white",
    stroke: "#0076CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.d474f06d2108402c684adc5e18803ec9.svg";
export { ForwardRef as ReactComponent };